export const DEVICE_WIDTHS = {
  smallPhone: 320,
  phone: 500,
  tablet: 768,
  desktop: 1024,
  largeDesktop: 1440,
};
